import get from 'lodash.get';

var storeModule = {
  state: () => {
    return {
      sideNavOpen: false,
      user: null,
      openTransactions: 0,
      zeroTransactionsPromise: null,
      zeroTransactionsResolver: null,
      onZeroTransactions: function () { },
      snackbarMessageProps: [],
      dragItemId: "",
      dragElement: null,
      guestSignInRevealed: false
    };
  },
  getters: {
    isSideNavOpen: state => state.sideNavOpen,
    settings: state => get(state, "user.setting"),
    isAuthenticated: state => !!state.user,
    hasOpenTransactions: state => !!state.openTransactions,
    waitForZeroTransactions: (state) => {
      if (state.zeroTransactionsPromise) {
        return state.zeroTransactionsPromise;
      } else {
        return Promise.resolve();
      }
    }
  },
  actions: {
    setSideNavOpen: function ({ open }) {
      this.sideNavOpen = open;
    },
    toggleSideNavOpen: function () {
      this.sideNavOpen = !this.sideNavOpen;
    },
    setUser: function (user) {
      this.user = user;
    },
    signOut: function () {
      this.user = null;
    },
    startTransaction: function () {
      this.openTransactions++;
      if (this.openTransactions === 1) {
        this.zeroTransactionsPromise = new Promise((resolve) => {
          this.zeroTransactionsResolver = resolve;
        });
      }
    },
    endTransaction: function () {
      this.openTransactions--;
      if (this.openTransactions === 0) {
        this.zeroTransactionsResolver();
        this.onZeroTransactions();
      }
    },
    setOnZeroTransactions: function (fn) {
      this.onZeroTransactions = fn;
    },
    pushSnackbarMessageProps: function (messageProps) {
      this.snackbarMessageProps.splice(this.snackbarMessageProps.length, 0, messageProps);
    },
    shiftSnackbarMessageProps: function () {
      this.snackbarMessageProps = this.snackbarMessageProps.slice(1);
    },
    setDragItemId: function (dragItemId) {
      this.dragItemId = dragItemId;
    },
    setDragElement: function (dragElement) {
      this.dragElement = dragElement;
    },
    setGuestSignInRevealed: function () {
      this.guestSignInRevealed = true;
    },
    trackTransaction: function (promise) {
      this.startTransaction();
      return promise
        .then((ret) => {
          this.endTransaction();
          return ret;
        })
        .catch((e) => {
          this.endTransaction();
          throw e;
        });
    }
  }
};

export { storeModule as default };
